import React, { useState, useEffect } from 'react';
import agentComponent from '../businesses/agent';
import { setViewFromAgentId } from '../redux/actions/agentActions';
import { useDispatch } from 'react-redux';

const SingleSignonPage = parentProps => {
    const key = parentProps.match.params.key || "";
    //const [isValidKey, setIsValidKey] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            if (key) {
                const agent = await agentComponent.singleSignon(key);
                console.log(agent)
                if (agent) {
                    dispatch(setViewFromAgentId(agent._id));
                    window.location.href = '/dashboard';
                    //setIsValidKey(true);
                }
            }
        })();
    }, []);

    const relogin = () => {
        window.location.href = process.env.REACT_APP_IPROFORMA_MAIN_PAGE;
    };

    return (
        <div className="lg:px-24 lg:py-24 md:py-20 md:px-44 px-4 py-24 items-center flex justify-center flex-col-reverse lg:flex-row md:gap-28 gap-16">
            <div className="xl:pt-24 w-full xl:w-1/2 relative pb-12 lg:pb-0">
                <div className="relative">
                    <div className="absolute">
                        <div className="">
                            <h1 className="my-2 text-gray-800 font-bold text-2xl">
                                Sorry, this link is no longer valid.
                            </h1>
                            <p className="my-2 text-gray-800">Sorry about that! Please visit our hompage to get where you need to go.</p>
                            <button onClick={relogin}
                                className="sm:w-full lg:w-auto my-2 border rounded md py-4 px-8 text-center bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-opacity-50">Take me there!</button>
                        </div>
                    </div>
                    <div>
                        <img src="https://i.ibb.co/G9DC8S0/404-2.png" />
                    </div>
                </div>
            </div>
            <div>
                <img src="https://i.ibb.co/ck1SGFJ/Group.png" />
            </div>
        </div>
    )
};

export default SingleSignonPage;